import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutIntro from './components/AboutIntro';
import AboutPersona from './components/AboutPersona';
import AboutMethod from './components/AboutMethod';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

import PageCta from '@/components/feature/PageCta';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  'name': '關於琮恩｜保險建築師專業保險規劃',
  'url': `${siteUrl}/about`,
  'description': '認識保險建築師陳琮恩，15年以上專業保險顧問經驗，以建築師思維為客戶量身打造保障藍圖。',
  'about': {
    '@type': 'Person',
    'name': '陳琮恩',
    'jobTitle': '保險建築師',
    'description': '擁有超過15年保險顧問經驗的專業保險規劃師，以建築師思維為客戶量身打造保障藍圖。',
    'knowsAbout': ['醫療保險', '家庭保障', '長期照護', '退休規劃', '保單健檢', '資產風險管理'],
  },
};

export default function About() {
  useTitle({
    title: '關於琮恩｜保險建築師專業保險規劃',
    description: '認識保險建築師陳琮恩，15年以上專業保險顧問經驗，以建築師思維為客戶量身打造保障藍圖。',
    canonicalPath: '/about',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <AboutHero />
      <AboutIntro />
      <AboutPersona />
      <AboutMethod />
      <PageCta />
      <Footer />
    </main>
  );
}